import type { FilterField, SelectFilterField } from '@/components/common/AdvancedFilter';
import type { BookEdition } from '@/features/product/types/product.types';
import { toFilterOptions } from '@/utils/filters';
import type { PromoItem, PromoItemType } from '../types/promotion.types';

export function getPromoItemTypeFilterField(
  itemTypes: PromoItemType[] | undefined,
): SelectFilterField {
  return {
    key: 'itemTypeId',
    label: 'Item Type',
    type: 'select',
    placeholder: 'All Item Types',
    options: toFilterOptions(itemTypes),
    searchable: true,
  };
}

export function getPromoBookEditionFilterField(
  editions: BookEdition[] | undefined,
): SelectFilterField {
  const editionsByNumber = (editions ?? []).flatMap((edition) =>
    edition.legacyId === null ? [] : [{ id: edition.legacyId, name: edition.name }],
  );
  return {
    key: 'bookEditionNo',
    label: 'Book Edition',
    type: 'select',
    placeholder: 'All Editions',
    options: toFilterOptions(editionsByNumber),
    searchable: true,
  };
}

export function getPromoItemFilterField(items: PromoItem[] | undefined): SelectFilterField {
  return {
    key: 'promoItemId',
    label: 'Promotional Item',
    type: 'select',
    placeholder: 'All Items',
    options: toFilterOptions(items),
    searchable: true,
  };
}

export function getItemCodeFilterField(): FilterField {
  return { key: 'itemCode', label: 'Item Code', type: 'text', placeholder: 'UMB-01' };
}
